import { useState } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import { Button, TextArea, Row, Col } from '@folio/stripes/components';

import css from './MessageInput.css';

const propTypes = {
  onSendMessage: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
};

const defaultProps = {
  disabled: false,
  placeholder: '',
};

const MessageInput = ({ onSendMessage, disabled, placeholder }) => {
  const intl = useIntl();
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    if (message.trim() && !disabled) {
      onSendMessage(message.trim());
      setMessage('');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={css.messageInputForm}>
      <Row>
        <Col xs={10}>
          <TextArea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            disabled={disabled}
            rows={3}
            resize="none"
            className={css.messageTextArea}
          />
        </Col>
        <Col xs={2}>
          <Button
            type="submit"
            buttonStyle="primary"
            disabled={!message.trim() || disabled}
            fullWidth
            className={css.sendButton}
            marginBottom0
          >
            {intl.formatMessage({ id: 'ui-plugin-smart-help.chat.send' })}
          </Button>
        </Col>
      </Row>
    </form>
  );
};

MessageInput.propTypes = propTypes;
MessageInput.defaultProps = defaultProps;

export default MessageInput;
